import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCargoInsurance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.70175 12.6897C6.87325 12.7812 7.0885 12.7807 7.26 12.6891C11.9337 10.1784 12.2656 5.27315 12.2615 3.8784C12.2611 3.7663 12.2279 3.65677 12.1662 3.56321C12.1044 3.46965 12.0167 3.39613 11.9138 3.35165L7.218 1.27148C7.14327 1.23854 7.06248 1.22158 6.98081 1.22168C6.89914 1.22178 6.8184 1.23894 6.74375 1.27207L2.08058 3.35224C1.97919 3.39674 1.89274 3.46944 1.83151 3.5617C1.77029 3.65395 1.73687 3.76186 1.73525 3.87257C1.71541 5.26032 1.99483 10.1761 6.70175 12.6897ZM5.06025 6.00407L6.39783 7.34165L8.90208 4.8374L9.72691 5.66224L6.39783 8.99132L4.23541 6.8289L5.06025 6.00407Z",
		fill: "#00B710"
	})
});
export default SvgCargoInsurance;
